// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { Link } from 'react-router-dom';
// // // // // import Navbar from '../Components/Navbar/Navbar';
// // // // // import Footer from '../Components/Footer/Footer';
// // // // // import { Helmet } from 'react-helmet';

// // // // // const Blogs = () => {
// // // // //   const [blogs, setBlogs] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [error, setError] = useState(null);

// // // // //   useEffect(() => {
// // // // //     const fetchBlogs = async () => {
// // // // //       try {
// // // // //         const response = await fetch('https://blog.dxbhost.agency/api/public/blogs', {
// // // // //           headers: {
// // // // //             'Authorization': 'Bearer b2a36854-edfb-49a9-9c2d-409baa3b497d'
// // // // //           }
// // // // //         });
// // // // //         if (!response.ok) {
// // // // //           throw new Error('Failed to fetch blogs');
// // // // //         }
// // // // //         const data = await response.json();
// // // // //         setBlogs(data.blogs || []);
// // // // //       } catch (err) {
// // // // //         setError(err.message);
// // // // //       } finally {
// // // // //         setLoading(false);
// // // // //       }
// // // // //     };

// // // // //     fetchBlogs();
// // // // //   }, []);

// // // // //   if (loading) return <div>Loading...</div>;
// // // // //   if (error) return <div>Error: {error}</div>;

// // // // //   return (
// // // // //     <div className="min-h-screen bg-background">
// // // // //       <Helmet>
// // // // //         <title>Blogs | Cardiac Rehab Insights</title>
// // // // //         <meta name="description" content="Read our latest blogs on cardiac rehab, heart health, and medical insights." />
// // // // //       </Helmet>
// // // // //       <Navbar />
// // // // //       <div className="container mx-auto px-4 py-8">
// // // // //         <h1 className="text-3xl font-bold mb-6">Blogs</h1>
// // // // //         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
// // // // //           {blogs.map(blog => (
// // // // //             <div key={blog.id} className="bg-white p-6 rounded-lg shadow-md">
// // // // //               <h2 className="text-xl font-semibold mb-2">{blog.title}</h2>
// // // // //               <p className="text-gray-600 mb-4">{blog.excerpt || blog.content?.substring(0, 100) + '...'}</p>
// // // // //               <p className="text-sm text-gray-500 mb-4">{new Date(blog.created_at).toLocaleDateString()}</p>
// // // // //               <Link to={`/blogs/${blog.id}`} className="text-blue-500 hover:underline">Read More</Link>
// // // // //             </div>
// // // // //           ))}
// // // // //         </div>
// // // // //       </div>
// // // // //       <Footer />
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default Blogs;

// // // // import React, { useState, useEffect } from "react";
// // // // import { Link } from "react-router-dom";
// // // // import Navbar from "../Components/Navbar/Navbar";
// // // // import Footer from "../Components/Footer/Footer";
// // // // import { Helmet } from "react-helmet";
// // // // import "./Blogs.css";

// // // // const Blogs = () => {
// // // //   const [blogs, setBlogs] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState(null);

// // // //   useEffect(() => {
// // // //     const fetchBlogs = async () => {
// // // //       try {
// // // //         const response = await fetch("https://blog.dxbhost.agency/api/public/blogs", {
// // // //           headers: {
// // // //             Authorization: "Bearer b2a36854-edfb-49a9-9c2d-409baa3b497d",
// // // //           },
// // // //         });

// // // //         if (!response.ok) throw new Error("Failed to fetch blogs");
// // // //         const data = await response.json();
// // // //         console.log("API Response:", data);
// // // //         setBlogs(data.blogs || []);
// // // //       } catch (err) {
// // // //         setError(err.message);
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     };
// // // //     fetchBlogs();
// // // //   }, []);

// // // //   const getImageUrl = (blog) => {
// // // //     if (blog.featuredImage?.url) return blog.featuredImage.url;
// // // //     return "/images/no-image.jpg";
// // // //   };

// // // //   if (loading) return <div className="loading">Loading...</div>;
// // // //   if (error) return <div className="error">Error: {error}</div>;

// // // //   return (
// // // //     <div className="blogs-container">
// // // //       <Helmet>
// // // //         <title>Blogs | </title>
// // // //         <meta
// // // //           name="description"
// // // //           content="Explore our latest blogs on real estate, property trends, and investment insights."
// // // //         />
// // // //       </Helmet>

// // // //       <Navbar />

// // // //       {/* ======= BLOG HERO SECTION ======= */}
// // // //       <div className="blogs-hero">
// // // //         <div className="blogs-hero-overlay">
// // // //           <h1 className="hero-title">Welcome to Our Ridge Homes Blogs</h1>
// // // //           <p className="hero-subtitle">
// // // //             Explore our captivating and enlightening articles, designed to empower you with
// // // //             valuable insights as a discerning real estate buyer.
// // // //           </p>
// // // //         </div>
// // // //       </div>

// // // //       {/* ======= BLOG GRID SECTION ======= */}
// // // //       <div className="blogs-section">
// // // //         <div className="blogs-grid">
// // // //           {blogs.map((blog) => (
// // // //             <div key={blog.id} className="blog-card">
// // // //               <div className="blog-image-container">
// // // //                 <img
// // // //                   src={getImageUrl(blog)}
// // // //                   alt={blog.title}
// // // //                   className="blog-image"
// // // //                   onError={(e) => (e.target.src = "/images/no-image.jpg")}
// // // //                 />
// // // //               </div>
// // // //               <div className="blog-content">
// // // //                 <h2 className="blog-title">{blog.title}</h2>
// // // //                 <p className="blog-excerpt">
// // // //                   {blog.metaDesc || blog.content.replace(/<[^>]+>/g, "").substring(0, 120) + "..."}
// // // //                 </p>
// // // //                 <Link to={`/blogs/${blog.slug}`} className="blog-readmore">
// // // //                   READ MORE...
// // // //                 </Link>
// // // //               </div>
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </div>

// // // //       <Footer />
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Blogs;


// // // import React, { useState, useEffect } from "react";
// // // import { Link } from "react-router-dom";
// // // import Navbar from "../Components/Navbar/Navbar";
// // // import Footer from "../Components/Footer/Footer";
// // // import { Helmet } from "react-helmet";
// // // import "./Blogs.css";

// // // const Blogs = () => {
// // //   const [blogs, setBlogs] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);

// // //   useEffect(() => {
// // //     const fetchBlogs = async () => {
// // //       try {
// // //         const response = await fetch("https://blog.dxbhost.agency/api/public/blogs", {
// // //           headers: {
// // //             Authorization: "Bearer b2a36854-edfb-49a9-9c2d-409baa3b497d",
// // //           },
// // //         });
// // //         if (!response.ok) throw new Error("Failed to fetch blogs");
// // //         const data = await response.json();
// // //         setBlogs(data.blogs || []);
// // //       } catch (err) {
// // //         setError(err.message);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };
// // //     fetchBlogs();
// // //   }, []);

// // //   const getImageUrl = (blog) => {
// // //     if (blog.featuredImage?.url) return blog.featuredImage.url;
// // //     return "/images/no-image.jpg";
// // //   };

// // //   if (loading) return <div className="loading">Loading...</div>;
// // //   if (error) return <div className="error">Error: {error}</div>;

// // //   return (
// // //     <div className="blogs-page">
// // //       <Helmet>
// // //         <title>Blogs | Heart Care</title>
// // //         <meta
// // //           name="description"
// // //           content="Discover expert insights on heart care, cardiac rehab, and wellness."
// // //         />
// // //       </Helmet>

// // //       <Navbar />

// // //       {/* ======= BLOG HEADER ======= */}
// // //       <div className="blogs-header">
// // //         <h1>Blogs</h1>
// // //         <p>Lorem Ipsum</p>
// // //       </div>

// // //       {/* ======= BLOG GRID ======= */}
// // //       <section className="blog-grid-section">
// // //         <div className="blog-grid">
// // //           {blogs.slice(0, 6).map((blog) => (
// // //             <div className="blog-card-new" key={blog.id}>
// // //               <div className="blog-img-wrapper">
// // //                 <img src={getImageUrl(blog)} alt={blog.title} />
// // //                 <span className="blog-tag">CARDIAC</span>
// // //               </div>
// // //               <div className="blog-card-body">
// // //                 <h3>{blog.title || "How sleep impacts your heart health"}</h3>
// // //                 <p>
// // //                   {blog.metaDesc ||
// // //                     blog.content.replace(/<[^>]+>/g, "").substring(0, 100) + "..."}
// // //                 </p>
// // //                 <Link to={`/blogs/${blog.slug}`} className="read-more-btn">
// // //                   Read More
// // //                 </Link>
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </section>

// // //       {/* ======= BOTTOM CONTACT SECTION ======= */}
// // //       <section className="heart-care-section">
// // //         <div className="heart-care-box">
// // //           <h2>Looking for the right support on your journey to heart health?</h2>
// // //           <h3>Get Heart Care Guidance</h3>

// // //           <form className="heart-form">
// // //             <input type="text" placeholder="Name" required />
// // //             <input type="tel" placeholder="Mobile Number" required />
// // //             <button type="submit">Submit</button>
// // //           </form>
// // //         </div>
// // //       </section>

// // //       <Footer />
// // //     </div>
// // //   );
// // // };

// // // export default Blogs;



// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // import Navbar from "../Components/Navbar/Navbar";
// // import Footer from "../Components/Footer/Footer";
// // import { Helmet } from "react-helmet";
// // import "./Blogs.css";

// // const Blogs = () => {
// //   const [blogs, setBlogs] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   useEffect(() => {
// //     const fetchBlogs = async () => {
// //       try {
// //         const response = await fetch("https://blog.dxbhost.agency/api/public/blogs", {
// //           headers: {
// //             Authorization: "Bearer b2a36854-edfb-49a9-9c2d-409baa3b497d",
// //           },
// //         });
// //         if (!response.ok) throw new Error("Failed to fetch blogs");
// //         const data = await response.json();
// //         setBlogs(data.blogs || []);
// //       } catch (err) {
// //         setError(err.message);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchBlogs();
// //   }, []);

// //   const getImageUrl = (blog) => {
// //     if (blog.featuredImage?.url) return blog.featuredImage.url;
// //     return "/images/no-image.jpg";
// //   };

// //   if (loading) return <div className="loading">Loading...</div>;
// //   if (error) return <div className="error">Error: {error}</div>;

// //   return (
// //     <div className="blogs-main">
// //       <Helmet>
// //         <title>Heart Care Blogs</title>
// //       </Helmet>

// //       <Navbar />

// //       {/* ======= TOP BANNER ======= */}
// //       <section className="blogs-banner">
// //         <div className="banner-content">
// //           <p className="banner-sub">Blogs</p>
// //           <h1 className="banner-title">Lorem Ipsum</h1>
// //         </div>
// //       </section>

// //       {/* ======= BLOG GRID ======= */}
// //       <section className="blogs-grid-section">
// //         <div className="blogs-grid">
// //           {blogs.slice(0, 6).map((blog) => (
// //             <div className="blog-card" key={blog.id}>
// //               <div className="blog-image-container">
// //                 <img src={getImageUrl(blog)} alt={blog.title} />
// //                 {/* <span className="tag">Cardiac Rehab</span> */}
// //               </div>
// //               <div className="blog-body">
// //                 <h3>{blog.title || "How sleep impacts your heart health and overall wellness?"}</h3>
// //                 <p>
// //                   {blog.metaDesc ||
// //                     blog.content.replace(/<[^>]+>/g, "").substring(0, 120) + "..."}
// //                 </p>
// //                 <Link to={`/blogs/${blog.slug}`} className="readmore">
// //                   Read More
// //                 </Link>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </section>

// //       {/* ======= HEART CARE CONTACT SECTION ======= */}
// //       <section className="heart-care-guidance">
// //         <div className="guidance-container">
// //           <h3>Looking for the right support on your journey to heart health?</h3>
// //           <h2>Get Heart Care Guidance</h2>

// //           <form className="guidance-form">
// //             <input type="text" placeholder="Name" required />
// //             <input type="tel" placeholder="Mobile Number" required />
// //             <button type="submit">Submit</button>
// //           </form>
// //         </div>
// //       </section>

// //       <Footer />
// //     </div>
// //   );
// // };

// // export default Blogs;


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// // import { Helmet } from "react-helmet";
// import "./Blogs.css";

// const Blogs = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchBlogs = async () => {
//       try {
//         const response = await fetch("https://blog.dxbhost.agency/api/public/blogs", {
//           headers: {
//             Authorization: "Bearer cb443e4d-a7ae-42c7-b6f6-5d2f651400c9",
//           },
//         });
//         if (!response.ok) throw new Error("Failed to fetch blogs");
//         const data = await response.json();
//         setBlogs(data.blogs || []);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBlogs();
//   }, []);

//   const getImageUrl = (blog) => {
//     if (blog.featuredImage?.url) return blog.featuredImage.url;
//     return "/images/no-image.jpg";
//   };

//   if (loading) return <div className="loading">Loading...</div>;
//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <div className="blogs-main">
//       {/* <Helmet> */}
//         <title>Heart Care Blogs</title>
//       {/* </Helmet> */}

     

//       {/* ======= TOP BANNER ======= */}
//       <section className="blogs-banner">
//         <div className="banner-content">
//           <p className="banner-sub">Blogs</p>
//           <h1 className="banner-title">Bakelore</h1>
//         </div>
//       </section>

//       {/* ======= BLOG GRID ======= */}
//       <section className="blogs-grid-section">
//         <div className="blogs-grid">
//           {blogs.slice(0, 6).map((blog) => (
//             <div className="blog-card" key={blog.id}>
//               <div className="blog-image-container">
//                 <img src={getImageUrl(blog)} alt={blog.title} />
//                 {/* <span className="tag">Cardiac Rehab</span> */}
//               </div>
//               <div className="blog-body">
//                 <h3>{blog.title || "How sleep impacts your heart health and overall wellness?"}</h3>
//                 <p>
//                   {blog.metaDesc ||
//                     blog.content.replace(/<[^>]+>/g, "").substring(0, 120) + "..."}
//                 </p>
//                 <Link to={`/blogs/${blog.slug}`} className="readmore">
//                   Read More
//                 </Link>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ======= HEART CARE CONTACT SECTION ======= */}
//       {/* <section className="heart-care-guidance">
//         <div className="guidance-container">
//           <h3>Looking for the right support on your journey to heart health?</h3>
//           <h2>Get Heart Care Guidance</h2>

//           <form className="guidance-form">
//             <input type="text" placeholder="Name" required />
//             <input type="tel" placeholder="Mobile Number" required />
//             <button type="submit">Submit</button>
//           </form>
//         </div>
//       </section> */}

//     </div>
//   );
// };

// export default Blogs;



// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./Blogs.css";

// const Blogs = () => {
//   const [blogs, setBlogs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchBlogs = async () => {
//       try {
//         const response = await fetch("https://blog.dxbhost.agency/api/public/blogs", {
//           headers: {
//             Authorization: "Bearer cb443e4d-a7ae-42c7-b6f6-5d2f651400c9",
//           },
//         });
//         if (!response.ok) throw new Error("Failed to fetch blogs");
//         const data = await response.json();
//         setBlogs(data.blogs || []);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBlogs();
//   }, []);

//   const getImageUrl = (blog) => (blog.featuredImage?.url ? blog.featuredImage.url : "/images/no-image.jpg");

//   if (loading) return <div className="loading">Loading...</div>;
//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <div className="blogs-main">
//       <title>Bakelore Blogs</title>

//       {/* TOP BANNER */}
//       <section className="blogs-banner">
//         <div className="banner-content">
//           <p className="banner-sub">Blogs</p>
//           <h1 className="banner-title">Bakelore</h1>
//         </div>
//       </section>

//       {/* BLOG GRID */}
//       <section className="blogs-grid-section">
//         <div className="blogs-grid">
//           {blogs.slice(0, 10).map((blog) => (
//             <Link
//               to={`/blogs/${blog.slug}`}
//               key={blog.id}
//               className="blog-card-link"
//               style={{ textDecoration: "none", color: "inherit" }}
//             >
//               <div className="blog-card">
//                 <div className="blog-image-container">
//                   <img src={getImageUrl(blog)} alt={blog.title} />
//                 </div>
//                 <div className="blog-body">
//                   <h3>{blog.title || "Blog Title"}</h3>
//                   <p>
//                     {blog.metaDesc ||
//                       blog.content.replace(/<[^>]+>/g, "").substring(0, 120) + "..."}
//                   </p>
//                   <span className="readmore">Read More</span>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Blogs;


import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Blogs.css";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loaderRef = useRef(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(
          "https://blog.dxbhost.agency/api/public/blogs",
          {
            headers: {
              Authorization:
                "Bearer cb443e4d-a7ae-42c7-b6f6-5d2f651400c9",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch blogs");
        const data = await response.json();
        setBlogs(data.blogs || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  /* 🔥 Infinite Scroll Observer */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleCount((prev) => prev + 6); // load more
        }
      },
      { threshold: 1 }
    );

    if (loaderRef.current) observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, []);

  const getImageUrl = (blog) =>
    blog.featuredImage?.url
      ? blog.featuredImage.url
      : "/images/no-image.jpg";

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="blogs-main">
      <title>Bakelore Blogs</title>

      {/* TOP BANNER */}
      <section className="blogs-banner">
        <div className="banner-content">
          <p className="banner-sub">Blogs</p>
          <h1 className="banner-title">Bakelore</h1>
        </div>
      </section>

      {/* BLOG GRID */}
      <section className="blogs-grid-section">
        <div className="blogs-grid">
          {blogs.slice(0, visibleCount).map((blog) => (
            <Link
              to={`/blogs/${blog.slug}`}
              key={blog.id}
              className="blog-card-link"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="blog-card">
                <div className="blog-image-container">
                  <img src={getImageUrl(blog)} alt={blog.title} />
                </div>
                <div className="blog-body">
                  <h3>{blog.title || "Blog Title"}</h3>
                  <p>
                    {blog.metaDesc ||
                      blog.contents
                        .replace(/<[^>]+>/g, "")
                        .substring(0, 120) + "..."}
                  </p>
                  <span className="readmore">Read More</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* 👇 Scroll Trigger */}
        {visibleCount < blogs.length && (
          <div ref={loaderRef} className="infinite-loader">
            Loading more blogs...
          </div>
        )}
      </section>
    </div>
  );
};

export default Blogs;
